import { Icon } from '@iconify/react';
import {useState}  from 'react';
import * as FormulaFunctions from '../utilities/FormulaFunctions';
import * as ServerComms from '../utilities/ServerComms';
import NormalIcon from '../StockItems/NormalIcon';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var tryConnect = props.tryConnect;
  var history = props.history;
  var sortBy = props.sortBy;
  var setSortBy = props.setSortBy;
  var justLoadHistory = props.justLoadHistory;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var clickBack = props.clickBack;
  var addToExtraScreen = props.addToExtraScreen;

  var filterLine;

  const [previousDappNameSearch, setPreviousDappNameSearch] = useState('');

  var prevLine = <p className='lead mb-0' onClick={clickBack} style={{cursor:'pointer'}}><u>Create New DApp Instead</u><br/></p>
//
  if (!history || history === 'loading'){
    return <div><br/><br/><br/>{prevLine}</div>
  }
//
  function selectHistory(programSetIDIn){
    return function(e){
      if (!programSetIDIn){
      }else{
        var passObject = {
            fn:'oldProgram',
            sessionID,
            signKey,
            userID,
            programSetID:programSetIDIn,
          };
        setDoingWhat({t:'old', programSetID:programSetIDIn});
        tryConnect(passObject);
      }

    }
  }


  function deleteProgram(programSetID){
    return function(e){
      var p = window.confirm('Are you sure you want to delete this dapp?');
      if (p){
        setDoingWhat({t:'delete', programSetID});
        ServerComms.fetchSomething({u:'deleteProgram', programSetID, sessionID, signKey, userID}, justLoadHistory);
      }
    }
  }
  function duplicateProgram(programSetID){
    return function(e){
      setDoingWhat({t:'duplicate', programSetID});
      ServerComms.fetchSomething({u:'duplicateProgram', programSetID, sessionID, signKey, userID}, justLoadHistory);
    }
  }

  function sortFunction(a, b){
    var aPrime; var bPrime;
    if (sortBy === 'Title'){
      aPrime = a.v[1].v.toLowerCase();
      bPrime = b.v[1].v.toLowerCase();
    }else if (sortBy === 'Created'){
      aPrime = -FormulaFunctions.currentDateFromSql(a.v[2]);
      bPrime = -FormulaFunctions.currentDateFromSql(b.v[2]);
    }else if (sortBy === 'URL'){
      aPrime = getUrlText(a);
      bPrime = getUrlText(b);
    }
    if (aPrime > bPrime){
      return 1;
    }else if (aPrime < bPrime){
      return -1;
    }else{
      return 0;
    }
  }

  function getUrlText(aHistory){
    var currentUrl = aHistory.v[5].v;
    if (currentUrl){
      var isAlive = FormulaFunctions.isDeploymentAlive(aHistory.v[4]);
      if (isAlive){
        return 'https://www.cues.sg/dapps/' + currentUrl;
      }else{
        return 'Expired';
      }
    }else{
      return ''
    }
  }

  var needToFilter = false;
  if (history.length > 10){
    needToFilter = true;

    function onChange(e){
      setPreviousDappNameSearch(e.target.value);
    }

    filterLine = <input autoFocus className='inputBoxClassLong' value={previousDappNameSearch} onChange={onChange} style={{width:'80%'}} placeholder='Filter by dApp Name' />

  }

  var lowerNameSearch = previousDappNameSearch.toLowerCase();


  var historyRows = history.filter((aHistory, index)=>{
    return !needToFilter || previousDappNameSearch === '' || aHistory.v[1].v.toLowerCase().indexOf(lowerNameSearch) > -1
  }).sort(sortFunction).map((aHistory, index)=>{
    var programSetID = aHistory.v[0].v;
    var createdDate = FormulaFunctions.getDateFromSql(aHistory.v[2]);

    var className = 'normalIcon';
    var onClick = selectHistory(programSetID);

    var clickUrl = onClick;
    var currentUrl = getUrlText(aHistory);
    if (currentUrl){
      var isAlive = FormulaFunctions.isDeploymentAlive(aHistory.v[4]);
      if (isAlive){
        clickUrl = function(){
            window.open(currentUrl);
        }
        className = 'normalIconBlack'
      }else{
        className = 'normalIconRed';
      }
    }

    var deletePiece;
    if (aHistory.v[7].v === 10){
      deletePiece = <NormalIcon title='Delete' icon='fe:trash' onClick={deleteProgram(programSetID)} />
    }
    
    var duplicatePiece = <NormalIcon title='Duplicate' icon='fa:copy' onClick={duplicateProgram(programSetID)} />
    var editPiece = <NormalIcon title='Edit' icon='ant-design:edit-outlined' onClick={onClick} />

    if (doingWhat){
      if (doingWhat.programSetID === programSetID){
        if (doingWhat.t === 'delete'){
          deletePiece = <div className='spinner-border' role='status'></div>        
        }else if (doingWhat.t === 'duplicate'){
          duplicatePiece = <div className='spinner-border' role='status'></div>        
        }else if (doingWhat.t === 'old'){
          editPiece = <div className='spinner-border' role='status'></div>        
        }
      }
    }
//  
//        
    return (<tr key={index} className={className}>
            <td onClick={onClick}>{aHistory.v[1].v}</td>
            <td onClick={onClick}>{createdDate}</td>
            <td onClick={clickUrl}>{currentUrl}</td>
            <td > {deletePiece} </td>
            <td > {duplicatePiece} </td>
            <td > {editPiece} </td>
          </tr>)
//

      });

  function clickSortBy(sortByWhat){
    return function(e){
      setSortBy(sortByWhat);
    }
  }

  var headers = ['Title', 'Created', 'URL'];
  var headerRows = headers.map((aHead, index)=>{

    var icon = 'ep:arrow-down'
    if (aHead === sortBy){
      icon = 'ep:arrow-down-bold';
    }

    return <th scope='col' onClick={clickSortBy(aHead)} style={{whiteSpace:'nowrap'}} key={index}>{aHead} <Icon width = '10' icon={icon} /></th>
  })
//      
  var oldItems = <table className='table table-hover'>
        <thead>
          <tr>
            {headerRows}
            <th scope='col'></th>
            <th scope='col'></th>
            <th scope='col'></th>
          </tr>
        </thead>
        <tbody>
          {historyRows}              
        </tbody>
      </table>              
//
  

    return <div className='container py-5'>
        <div className='row mb-4'>
      <div className='col-lg-8 mx-auto text-center'>
        <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'introPrevious'}} />
        <h1 className='display-4' >Previous dApps</h1>
        {prevLine}
        <br/>
        {filterLine}
      </div>
      </div>
        <div className='row mb-4'>
      <div className='col-12 mx-auto text-center'>
        {oldItems}
      </div>
      </div>
    </div>


//
}

export default App;
